export function HowItWorks() {
  const steps = [
    {
      step: '1',
      title: 'Ask Your Question',
      description: 'Type your data question in plain English, just like talking to a colleague.',
      example: '"What were our best-selling products last month?"',
    },
    {
      step: '2',
      title: 'AI Generates SQL',
      description: 'Our AI understands your question and creates secure, optimized SQL queries.',
      example: 'SELECT product_name, SUM(quantity) FROM...',
    },
    {
      step: '3',
      title: 'Get Instant Results',
      description: 'View your data in tables, charts, and summaries with actionable insights.',
      example: '📊 Interactive charts and key metrics',
    },
  ];

  return (
    <section id="how-it-works" className="section-padding bg-gray-50">
      <div className="container-wrapper">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            How QueryZen Works
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Three simple steps to transform your natural language questions 
            into actionable data insights.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {steps.map((step, index) => (
            <div key={index} className="text-center">
              <div className="relative mb-8">
                <div className="w-16 h-16 bg-primary-600 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4">
                  {step.step}
                </div>
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-8 left-1/2 w-full h-0.5 bg-primary-200 -z-10"></div>
                )}
              </div>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                {step.title}
              </h3>
              
              <p className="text-gray-600 mb-4">
                {step.description}
              </p>
              
              <div className="bg-white border border-gray-200 rounded-lg p-4 text-sm text-gray-700 font-mono">
                {step.example}
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-16 text-center">
          <div className="bg-primary-50 border border-primary-200 rounded-lg p-8 max-w-2xl mx-auto">
            <h3 className="text-xl font-semibold text-primary-800 mb-2">
              Built for Business Users
            </h3>
            <p className="text-primary-700">
              No SQL knowledge required. No database access needed. 
              Just ask your questions and get the insights you need to make better decisions.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
